import React from 'react';

class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        const isChunkError =
            error?.name === 'ChunkLoadError' ||
            /Loading chunk \d+ failed/.test(error?.message || '') ||
            /Loading CSS chunk/.test(error?.message || '');
        if (isChunkError) return { hasError: true };
        return null;
    }

    componentDidCatch(error) {
        if (this.state.hasError) {
            console.warn('ChunkLoadError caught — likely a stale build after deploy:', error);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh', background: '#200043', color: '#fff',
                    fontFamily: 'Nunito, sans-serif',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
                }}>
                    <div style={{
                        maxWidth: 420, padding: 32, textAlign: 'center',
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(139,92,246,0.3)',
                        borderRadius: 16,
                        boxShadow: '0 0 24px rgba(139,92,246,0.2)',
                    }}>
                        <div style={{ fontSize: 44, marginBottom: 8 }}>✨</div>
                        <h2 style={{ fontFamily: 'Sora, sans-serif', fontSize: 22, fontWeight: 700, margin: '0 0 8px 0' }}>
                            CareerStar was just updated
                        </h2>
                        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5, margin: '0 0 20px 0' }}>
                            We just shipped some improvements. Refresh to load the latest version.
                        </p>
                        <button onClick={() => window.location.reload()} style={{
                            padding: '10px 24px',
                            background: 'linear-gradient(135deg, #8B5CF6, #7c3aed)',
                            color: '#fff', border: 'none', borderRadius: 12,
                            fontSize: 14, fontWeight: 700, fontFamily: 'Sora, sans-serif',
                            cursor: 'pointer',
                        }}>
                            Refresh Now
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ChunkErrorBoundary;
